import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefershIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5 6C11.5 8.76 9.26 11 6.5 11C3.74 11 2.055 8.22 2.055 8.22M2.055 8.22H4.315M2.055 8.22V10.72M1.5 6C1.5 3.24 3.72 1 6.5 1C9.835 1 11.5 3.78 11.5 3.78M11.5 3.78V1.28M11.5 3.78H9.28",
		stroke: "#A0A0A0",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefershIcon;
